import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';
import { downloadFile } from '../../../helpers/downloadFile';
import generateUrlFromBlob from '../../../helpers/generateUrlFromBlob';

const getHousingStockCommonFile = (fileNameWithExt) => {
  return client.get(`/HousingStock/common_file/${fileNameWithExt}`, {
    headers: authHeader(),
  });
};

export const downloadHousingStockCommonFile = async (fileName) => {
  try {
    const response = await getHousingStockCommonFile(fileName);
    if (response.status !== 200) {
      throw new Error();
    }
    const url = generateUrlFromBlob(response.data);
    downloadFile({ fileName, url, revoke: true });
  } catch (error) {
    message.error(`Произошла ошибка при скачивании файла "${fileName}"`);
  }
};
